import React from "react";

const UnAvailableTag = () => {
  return (
    <div style={styles.outOfStockContainer}>
      <span style={styles.outOfStock}>Unavailable</span>
    </div>
  );
};

const styles = {
  outOfStock: {
    textTransform: "capitalize",
    color: "white",
    textAlign: "center",
    fontSize: "10px",
    fontWeight: 600,
    borderColor: "white",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "6px",
    padding: "2px 4px",
    display: "inline-block",
  },
  outOfStockContainer: {
    position: "absolute",
    backgroundColor: "red",
    padding: "2px",
    borderRadius: "8px",
  },
};

export default UnAvailableTag;
